// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ie-1";
export var quotedThread = "_ie-0";